/**
 * harness/haptics.js
 * T-Cron-2026-10-24 02:00 早间 (round-1-of-day) — 改进清单 #3「触感反馈」收口
 *
 * 现状:buzz() 在 PostDetail / FavoriteBar / App 里各写了一份,
 *   三份的「尊重 prefers-reduced-motion」判断还得各自保持一致 ——
 *   漏一份就意味着开了「减弱动态效果」的用户仍会收到震动。
 *   ⇒ 收口到单一实现。
 *
 * 契约:
 *   · 不支持 navigator.vibrate 的设备(桌面 Safari / Firefox)静默跳过;
 *   · 用户开了「减弱动态效果」⇒ 静默跳过(震动属于动态效果的一部分);
 *   · 任何异常都吞掉 —— 触感反馈永远不能把主流程带崩。
 */

/**
 * 触发一次触感反馈。
 * @param {number|number[]} pattern 毫秒数,或 [短, 间隔, 短] 这样的节奏
 */
export function buzz(pattern = 8) {
  try {
    if (typeof navigator === 'undefined') return false;
    if (typeof navigator.vibrate !== 'function') return false;
    if (typeof window !== 'undefined'
      && window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return false;
    }
    navigator.vibrate(pattern);
    return true;
  } catch (_) {
    return false;
  }
}

const Haptics = { buzz };

window.Haptics = Haptics;

export default Haptics;
